const general_event = require('../../config/general_event');
const { excute_linux_command, recursiveAsyncReadLine } = require('../../action/common');

const get_diskIO_info = async () => {
  const disk_info = await excute_linux_command("iostat -x 1 1");
  const disk_info_json = convertDiskStatsToJson(disk_info);
  return disk_info_json;
}

let disk_monitor_instance = null;

const diskIO_monitor_start = (interval) => {
  if (check_diskIO_monitor_status()) return;
  if (!interval) interval = 2500;
  const interval_callback = async () => {
    const disk_info = await get_diskIO_info();
    general_event.emit("diskIO_monitor", disk_info);
  }
  interval_callback();
  disk_monitor_instance = setInterval(interval_callback, interval);
}

const diskIO_monitor_stop = () => {
  clearInterval(disk_monitor_instance);
  disk_monitor_instance = null;
}

const check_diskIO_monitor_status = () => {
  return disk_monitor_instance !== null;
}

/**
 * Converts Linux disk I/O statistics output to JSON format.
 * @param {string} input - The raw input string containing disk I/O statistics.
 * @returns {Object} An object containing parsed disk I/O statistics.
 */
function convertDiskStatsToJson(input) {
  const lines = input.trim().split('\n');
  const result = {
    systemInfo: {},
    cpuUsage: {},
    devices: []
  };

  // Parse system info
  const sysInfoMatch = lines[0].match(/(.+)\s+(\d+\/\d+\/\d+)\s+(.+)\s+\((\d+)\s+CPU\)/);
  if (sysInfoMatch) {
    result.systemInfo = {
      system: sysInfoMatch[1].trim(),
      date: sysInfoMatch[2],
      architecture: sysInfoMatch[3],
      cpuCount: parseInt(sysInfoMatch[4])
    };
  }

  // Parse CPU usage
  const cpuHeaders = lines[2].trim().split(/\s+/).slice(1);
  const cpuValues = lines[3].trim().split(/\s+/).slice(1);
  result.cpuUsage = Object.fromEntries(cpuHeaders.map((header, index) => [header.replace('%', ''), parseFloat(cpuValues[index])]));

  // Parse device statistics
  const deviceHeaders = lines[5].trim().split(/\s+/);
  for (let i = 6; i < lines.length; i++) {
    const deviceValues = lines[i].trim().split(/\s+/);
    const deviceStats = {};
    deviceHeaders.forEach((header, index) => {
      if (index === 0) {
        deviceStats[header] = deviceValues[index];
      } else {
        deviceStats[header] = parseFloat(deviceValues[index]);
      }
    });
    result.devices.push(deviceStats);
  }

  return result;
}

if (require.main === module) {
  const help_message = `
  1. get_diskIO_info
  2. diskIO_monitor_start
  3. diskIO_monitor_stop
  4. check_diskIO_monitor_status
  `
  console.log(help_message);

  const diskIO_monitor_callback = (disk_info) => {
    console.log(disk_info);
  }
  recursiveAsyncReadLine(async (input) => {
    switch (input) {
      case "1":
        get_diskIO_info().then((result) => {
          console.log(result);
        }).catch((error) => {
          console.error(error);
        });
        break;
      case "2":
        diskIO_monitor_start();
        general_event.on("diskIO_monitor", diskIO_monitor_callback);
        break;
      case "3":
        general_event.off("diskIO_monitor", diskIO_monitor_callback);
        if (general_event.listenerCount("diskIO_monitor") === 0) diskIO_monitor_stop();
        break;
      case "4":
        console.log(check_diskIO_monitor_status());
        break;
      default:
        console.log(help_message);
        break;
    }
  });
}

module.exports = {
  get_diskIO_info,
  diskIO_monitor_start,
  diskIO_monitor_stop,
  check_diskIO_monitor_status
}